import { render, staticRenderFns } from "./ContDatasetAssignment.vue?vue&type=template&id=333d5b44&lang=pug"
import script from "./ContDatasetAssignment.vue?vue&type=script&lang=js"
export * from "./ContDatasetAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('333d5b44')) {
      api.createRecord('333d5b44', component.options)
    } else {
      api.reload('333d5b44', component.options)
    }
    module.hot.accept("./ContDatasetAssignment.vue?vue&type=template&id=333d5b44&lang=pug", function () {
      api.rerender('333d5b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/ContDatasetAssignment.vue"
export default component.exports